import Reveal from '../common/Reveal';
import MarqueeRow from '../common/MarqueeRow';
import BreathingBlocks from '../Hero/BreathingBlocks';
import './PromoSection.css';

// Swap this for your own docs URL whenever you have one - it's the only
// place the "Learn more" link is set.
const LEARN_MORE_URL = 'https://docs.coti.io/coti-documentation';

const BULLETS = [
  'End-to-end privacy',
  'Confidential smart contracts',
  'Composable, programmable privacy',
  'Lightweight computation, regardless of complexity',
];

// Each demo card links out - point these at your real videos whenever
// you have them. All four go to youtube.com as a placeholder for now.
const DEMOS = [
  {
    label: 'Wallet Privacy Demo',
    image: '/images/demos/wallet-privacy.png',
    href: 'https://youtube.com',
  },
  {
    label: 'Private Voting',
    image: '/images/demos/private-voting.png',
    href: 'https://youtube.com',
  },
  {
    label: 'Age Guessing Game',
    image: '/images/demos/age-guessing.png',
    href: 'https://youtube.com',
  },
  {
    label: 'Wallet Snap',
    image: '/images/demos/wallet-snap.png',
    href: 'https://youtube.com',
  },
];

// Top row - scrolls left. Save matching images to public/images/community/.
const COMMUNITY = [
  {
    image: '/images/community/member-1.jpg',
    blurb: 'Founded a privacy-focused Web3 talent network.',
    name: 'Nguyen Duong',
    role: 'COTI Builder',
  },
  {
    image: '/images/community/member-2.jpg',
    blurb: 'Founder of a no-code platform for accessible smart contract development.',
    name: 'Nicolas Voisin',
    role: 'COTI Builder',
  },
  {
    image: '/images/community/member-3.jpg',
    blurb: 'Host, creator, and the voice of the community.',
    name: 'Mat Leveille',
    role: 'COTI  Ambassador',
  },
  {
    image: '/images/community/member-4.jpg',
    blurb: 'Community member turned content writer.',
    name: 'Guy Brandon',
    role: 'COTI  Creator',
  },
  {
    image: '/images/community/member-5.jpg',
    blurb: 'Driving growth across the ecosystem.',
    name: 'Soeren Jensen',
    role: 'COTI  Ambassador',
  },
  {
    image: '/images/community/member-6.jpg',
    blurb: 'Founded a privacy-focused Web3 talent network.',
    name: 'Giang',
    role: 'COTI  Builder',
  },
];

// Bottom row - scrolls right. Save matching images to public/images/highlights/.
const HIGHLIGHTS = [
  { image: '/images/highlights/highlight-1.jpg', caption: 'The RWA Summit Roundtable, Dubai 2025' },
  { image: '/images/highlights/highlight-2.jpg', caption: 'Vibe Code Session, Bangkok' },
  { image: '/images/highlights/highlight-3.jpg', caption: 'Royal Palace Visit, Dubai' },
];

export default function PromoSection() {
  return (
    <section id="protocol" className="promo">
      <BreathingBlocks className="promo__blocks" />
      <div className="container promo__intro">
        <Reveal as="up">
          <span className="eyebrow">The protocol</span>
        </Reveal>
        <Reveal as="up" delay={0.08}>
          <h2 className="promo__title">
            The fastest <span className="gradient-text">privacy layer</span> in Web3
          </h2>
        </Reveal>
        <Reveal as="up" delay={0.14} className="promo__body">
          <p>
            COTI uses battle-tested cryptography to serve fast, scalable privacy-on-demand to
            projects on any chain.
          </p>
          <ul className="promo__bullets">
            {BULLETS.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
          <a href={LEARN_MORE_URL} target="_blank" rel="noreferrer" className="btn btn--solid">
            Learn more
          </a>
        </Reveal>
      </div>

      <div className="container">
        <Reveal as="up">
          <h3 className="promo__subtitle">Demos</h3>
        </Reveal>
        <div className="promo__demos">
          {DEMOS.map((demo, i) => (
            <Reveal as="up" delay={0.05 * i} key={demo.label}>
              <a className="demo-card" href={demo.href} target="_blank" rel="noreferrer">
                <img src={demo.image} alt={demo.label} loading="lazy" />
                <span className="demo-card__label">{demo.label}</span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="promo__community">
        <MarqueeRow
          items={COMMUNITY}
          duration={34}
          renderItem={(person) => (
            <div className="community-card">
              <img src={person.image} alt={person.name} loading="lazy" />
              <div className="community-card__text">
                <p className="community-card__blurb">{person.blurb}</p>
                <p className="community-card__name">{person.name}</p>
                <p className="community-card__role">{person.role}</p>
              </div>
            </div>
          )}
        />
        <MarqueeRow
          items={HIGHLIGHTS}
          duration={38}
          reverse
          className="marquee-row--photos"
          renderItem={(item) => (
            <div className="highlight-card">
              <img src={item.image} alt={item.caption} loading="lazy" />
              <span className="highlight-card__caption">{item.caption}</span>
            </div>
          )}
        />
      </div>
    </section>
  );
}